import i18n from "../services/i18n"

// tog'a #2728 (2026-09-24): hamkor to'lovni tasdiqlaganda oynada faqat «Ошибка» chiqdi — sababi ko'rinmadi.
// Oldingi `xato.response.data.message || «Ошибка»` naqshi server javobidagi sababni yo'qotardi:
//  - 500 javobida matn `Message` (bosh harf) maydonida keladi (ExceptionHandlingMiddleware);
//  - huquq 403'i va tarmoq uzilishida tanada matn umuman yo'q;
//  - sessiya tugagan (401) holat ham oddiy «Ошибка» bo'lib ko'rinardi.
// Endi foydalanuvchi har doim ANIQ sababni ko'radi: server matni yoki holat ma'nosi.
export function apiErrorText(e: any): string {
  const d = e?.response?.data
  let firstValidation: any = null
  try { if (d?.errors && typeof d.errors === "object") firstValidation = (Object.values(d.errors) as any[]).flat()[0] } catch {}
  const serverMsg = (typeof d === "string" && d.length < 300 ? d : null) || d?.message || d?.Message || d?.error || firstValidation || d?.title
  if (serverMsg) return String(serverMsg)
  const status = e?.response?.status
  if (!e?.response) return i18n.t("errNetwork")
  if (status === 401) return i18n.t("errUnauthorized")
  if (status === 403) return i18n.t("insufficientRightsUpdated")
  if (status === 404) return i18n.t("errNotFound")
  if (status >= 500) return `${i18n.t("errServer")} (${status})`
  return `${i18n.t("errGeneric")}${status ? ` (${status})` : ""}`
}
